import { axiosAWSConsumer as axiosConsumer } from "../../utils";

export const contactServiceTicket = async (body: any) => {
  const { data } = await axiosConsumer.post(
    `/contact-service/desk-ticket`,
    body
  );
  return data.data;
};

export const cancellationServiceTicket = async (body: any) => {
  const { data } = await axiosConsumer.post(
    `/cancellation-service/desk-ticket`,
    body
  );
  return data.data;
};

export const getPreSignedUrl = async ({
  fileExtension,
  fileType,
  reqId,
}: {
  fileExtension: string;
  fileType: string;
  reqId: string;
}) => {
  const { data } = await axiosConsumer.get(
    `/contact-service/file-upload-url?fileExtension=${fileExtension}&fileType=${fileType}&reqId=${reqId}`
  );
  return data;
};
